export default __webpack_public_path__ + "static/media/AssemblerMk1.256.4f9c2f74.png";